export default __webpack_public_path__ + "static/media/wh_icon_magento.3ffc8988.svg";